/**
 * COPIED FROM EndUserApp src/lib/resin/resinize.js
 */

const resinize = (name: string): string =>
  name.toLowerCase().replace(/[^a-z0-9A-Z|]/g, '');

export default resinize;
